<!-- Invitation -->
<main class="row justify-content-center align-items-center h-100">
  <div class="col-8 col-md-8 col-lg-6 col-xl-6">

    <div class="row">

      <div class="offset-md-1 col-md-10 col-lg-8 offset-lg-2" *ngIf="!loading">

        <section class="row logo mb-4">
          <div class="col-12">
            <h1 class="float-left" *ngIf="!userAlreadyRegistered">Registration Complete!</h1>
            <h1 class="float-left" *ngIf="userAlreadyRegistered">Registration Already Done!</h1>
            <img src="assets/images/logo.svg#logo" alt="Learningmate - Frost align" class="float-right" />
          </div>
        </section>

        <ng-container *ngIf="!userAlreadyRegistered">
          <p class="font-bold">Congratulations!</p>
          <p class="font-bold">
            You can now access the "Frost align" instance for "{{orgName}}". You can login using the previously set user I'd
            and password.
          </p>
        </ng-container>
        <p class="font-bold" *ngIf="userAlreadyRegistered">
          You are already registered to "Frost align" instance for "{{orgName}}". You can login using the previously set User
          ID and Password.
        </p>


        <div class="row align-items-center login--btn-set">
          <div class="col login">
            <button type="button" class="btn btn-primary btn__login" (click)="goToLogin(false)">Done</button>
          </div>
          <div class="col text-right">
            <button type="button" class="btn text-underline btn-link-text" (click)="goToLogin(true)">Reset
              Password</button>
          </div>
        </div>

      </div>

    </div>

  </div>
</main>
<!-- Invitation -->
